var Q = Object.defineProperty, T = Object.defineProperties;
var E = Object.getOwnPropertyDescriptors;
var p = Object.getOwnPropertySymbols;
var h = Object.prototype.hasOwnProperty, $ = Object.prototype.propertyIsEnumerable;
var P = (e, t, s) => t in e ? Q(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, u = (e, t) => {
  for (var s in t || (t = {}))
    h.call(t, s) && P(e, s, t[s]);
  if (p)
    for (var s of p(t))
      $.call(t, s) && P(e, s, t[s]);
  return e;
}, S = (e, t) => T(e, E(t));
var U = (e, t) => {
  var s = {};
  for (var r in e)
    h.call(e, r) && t.indexOf(r) < 0 && (s[r] = e[r]);
  if (e != null && p)
    for (var r of p(e))
      t.indexOf(r) < 0 && $.call(e, r) && (s[r] = e[r]);
  return s;
};
var l = (e, t, s) => new Promise((r, i) => {
  var f = (d) => {
    try {
      o(s.next(d));
    } catch (m) {
      i(m);
    }
  }, y = (d) => {
    try {
      o(s.throw(d));
    } catch (m) {
      i(m);
    }
  }, o = (d) => d.done ? r(d.value) : Promise.resolve(d.value).then(f, y);
  o((s = s.apply(e, t)).next());
});
import { u as F, a as K } from "./query-client-DZ5Df1It.js";
import { u as A } from "./useMutation-DFzOBEuf.js";
import { u as M } from "./use-user-CwEHAZOt.js";
import { u as O } from "./use-cart-D8NOb7eE.js";
import { m as g, r as c } from "./define-element-XpjsV6s1.js";
import { i as _ } from "./utils-CMsllPx8.js";
function N(e) {
  const i = e, { businessName: t, address2: s } = i, r = U(i, ["businessName", "address2"]);
  return u(u(u({}, r), s !== void 0 ? { address_2: s } : {}), t !== void 0 ? { company: t } : {});
}
function I(e) {
  return u(u(u({}, e), e.address_2 !== void 0 ? { address2: e.address_2 } : {}), e.company !== void 0 ? { businessName: e.company } : {});
}
function L() {
  const e = F(), { isValidUser: t } = M(), { cart: s, fetchCart: r } = O(), i = K({
    queryKey: ["addresses", t],
    queryFn: () => l(null, null, function* () {
      if (!t.value)
        return [];
      let n = yield c("addresses");
      return Array.isArray(n) || (n = Object.keys(n).map((a) => n[a])), n.map((a) => (a = I(a), _(a.title) && (a.title = `${a.address} ${a.city}, ${a.state} ${a.zip}`), a));
    })
  }), f = A({
    mutationFn: (n) => l(null, null, function* () {
      const a = yield c("addresses", {
        method: "POST",
        body: JSON.stringify(N(n))
      });
      return yield c(`cart/address/${a}/select`, {
        method: "PUT"
      }), yield r(), a;
    }),
    onSuccess: () => {
      e == null || e.invalidateQueries({ queryKey: ["addresses"] });
    }
  }), y = A({
    mutationFn: (n) => l(null, null, function* () {
      yield c(`addresses/${n.id}`, {
        method: "PUT",
        body: JSON.stringify(N(n))
      });
      const a = yield c(`cart/address/${n.id}/select`, {
        method: "PUT"
      });
      return yield r(), a;
    }),
    onSuccess: () => {
      e == null || e.invalidateQueries({ queryKey: ["addresses"] });
    }
  }), o = A({
    mutationFn: (n) => l(null, null, function* () {
      return yield c(`addresses/${n}`, {
        method: "DELETE"
      }), yield r(), !0;
    }),
    onSuccess: () => {
      e == null || e.invalidateQueries({ queryKey: ["addresses"] });
    }
  }), d = g(() => i.data.value && i.data.value.length > 0), m = g(() => {
    var w;
    if (!d.value || !s.value)
      return null;
    const n = parseInt((w = s.value.config) == null ? void 0 : w.address_id, 10);
    let a = null;
    return isNaN(n) ? a = i.data.value.find(
      (v) => v.default === "1"
    ) : a = i.data.value.find(
      (v) => parseInt(v.id, 10) === n
    ), a || (a = i.data.value[0]), a;
  }), b = g(() => i.isPending.value || f.isPending.value || y.isPending.value || o.isPending.value);
  return S(u({}, i), {
    hasAddresses: d,
    selectedAddress: m,
    createAddressMutation: f,
    updateAddressMutation: y,
    deleteAddressMutation: o,
    isAnyAddressPending: b
  });
}
export {
  L as u
};
